import $ from 'jquery'
import "slick-carousel";
class WidgetECFJumpTo extends elementorModules.frontend.handlers.Base {
    getDefaultSettings() {
        return {
            // Tạo variables class cần DOM trong widget
            selectors: {
                menu: '#jump-menu'
            },
        };
    }

    getDefaultElements() {
        const selectors = this.getSettings( 'selectors' );
        return {
            $menu: this.$element.find(selectors.menu),
        };
    }

    bindEvents() {
        const THIS = this
        let $menu = this.elements.$menu[0]
        let scrollXMenu = $menu.querySelector('.list-item-jump-menu')
        let widthDevice = window.outerWidth;
        window.onscroll = function (e) {
            let offsetBox = document.querySelector('.offset-box');
            let scrollDistance = $(window).scrollTop();
            let offsetBoxBottom = $(offsetBox).offset().top + offsetBox.clientHeight - 250
            if ( offsetBoxBottom  <= scrollDistance) {
                $menu.classList.add('active');
            }else{
                $menu.classList.remove('active');
            }
        }
        if(widthDevice<768){
            $(scrollXMenu).slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: false,
                infinite: false,
                focusOnSelect: true,
                variableWidth: true,
                arrows:false,
                useTransform:false,
                // centerMode:true,
                // centerPadding:'0x',
              });
        }
        $(window).scroll(function() {
            let scrollDistance = $(window).scrollTop();
            // Assign active class to nav links while scolling
            let SectionDOM = $('.section')
            let SectionDOMLength = SectionDOM.length;
            SectionDOM.each(function($index,value) {
                if ($(this).offset().top - 200 <= scrollDistance) {
                    $('.item-jump-menu.active').removeClass('active');
                    let $activeHref = $(`.item-jump-menu[href="#${$(this).attr('id')}"]`)
                    $activeHref.addClass('active');
                    if(widthDevice<768){
                        $(scrollXMenu).slick('slickGoTo', $index, true);
                        if($index==SectionDOMLength-1){
                            let getSlickTrack = document.querySelector('.list-item-jump-menu .slick-track');
                            let listSlideItem = document.querySelectorAll('.list-item-jump-menu .slick-track .slick-slide');
                            let styleList = getSlickTrack.getAttribute("style").split(";");
                            let styleLeft = styleList[styleList.length-2].split(":");
                            let getWidthLastItem = listSlideItem[listSlideItem.length-1].offsetWidth;
                            $(getSlickTrack).css("left",parseInt(styleLeft[styleLeft.length-1])-getWidthLastItem);
                        }
                    }
                }
            });
        });
    }
}

jQuery( window ).on( 'elementor/frontend/init', () => {
    const addHandler = ( $element ) => {
        elementorFrontend.elementsHandler.addHandler( WidgetECFJumpTo, {
            $element,
        } );
    };
    // efc_form_donate ->Name widget register in php
    elementorFrontend.hooks.addAction( 'frontend/element_ready/ecf_jump_to.default', addHandler );
} );

